<template>
  <div>
    <b-row align-v="center">
      <b-col cols="3">
        <v-select
          label="Perfil"
          outlined
          dense
          :items="profiles"
          :loading="loading"
          v-model="profile_id"
          @change="getPermissions"
          item-text="name"
          item-value="id"
        />
      </b-col>
      <b-col>
        <v-text-field
          outlined
          dense
          append-icon="mdi-magnify"
          label="Pesquisar"
          :loading="loading"
          v-model="search"
        />
      </b-col>
    </b-row>

    <ErrorsMessages :errors="errors" />

    <b-row>
      <b-col>
        <v-data-table
          height="400px"
          dense
          :headers="headers"
          :items="permissions_items"
          :search="search"
          :footer-props="{
            'items-per-page-options': [200, 300, 400],
            'items-per-page-text': 'Mostrar',
          }"
          :loading="loading"
          group-by="group_name"
        >
          <template
            v-slot:[`group.header`]="{ group, headers, toggle, isOpen }"
          >
            <td :colspan="headers.length" @click="toggle">
              <v-btn x-small icon :ref="group">
                <v-icon v-if="isOpen">mdi-plus</v-icon>
                <v-icon v-else>mdi-minus</v-icon>
              </v-btn>
              <span class="ml-2">{{ group.toUpperCase() }}</span>
            </td>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-row>
              <v-col cols="3" v-for="action in item.actions" :key="action.id">
                <label>{{ action.name }}</label>
                <v-switch
                  color="primary"
                  class="mx-0 my-0"
                  dense
                  hide-details
                  inset
                  v-model="action.allowed"
                  @change="toggleAction(item, action)"
                />
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ErrorsMessages from "../components/ErrorsMessages";

import api from "../../services/api";
import { adminData } from "../../lib/functions";
import toast from "../../components/ToastNotification";

export default {
  name: "PermissionsAlt",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      permissions: {},
      errors: [],
      loading: false,

      rest_home_id: "",

      //profiles
      profiles: [],
      profile_id: "",

      //permissions
      search: "",
      headers: [
        { text: "Grupo", value: "group_name" },
        { text: "Nome", value: "name" },
        { text: "Ações", value: "actions", filterable: false },
      ],
      permissions_items: [],
    };
  },
  created() {
    this.permissions = adminData().permissions;

    const { id } = this.$attrs;
    this.rest_home_id = id;

    this.retrieve();
  },
  methods: {
    async retrieve() {
      await this.getProfiles();
      if (this.profiles.length > 0) this.profile_id = this.profiles[0].id;
      await this.getPermissions();
    },

    async getProfiles() {
      try {
        this.loading = true;

        const params = { rest_home_id: this.rest_home_id };
        const response = await api.get("/admin/rest-home/profiles", { params });
        const { error, errors, profiles } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.profiles = profiles;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getPermissions() {
      try {
        this.loading = true;

        const params = {
          rest_home_id: this.rest_home_id,
          profile_id: this.profile_id,
        };
        let response = await api.get(
          "/admin/rest-home/permissions/by-profile",
          { params }
        );
        const { error, errors, permissions } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.permissions_items = permissions;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async toggleAction(item, action) {
      this.loading = true;

      try {
        const data = {
          rest_home_id: this.rest_home_id,
          profile_id: this.profile_id,
          permission_id: item.id,
          action_id: action.id,
        };
        const response = await api.patch(
          "/admin/rest-home/permission/toggle",
          data
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          await this.getPermissions();
        }
      } catch (error) {
        console.log(error);
      }

      this.loading = false;
    },
  },
};
</script>